import { scroller } from './smoothScroll';
import _ from 'underscore';
import { gsap, Power4, Power1, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default (els) => {
	Array.prototype.forEach.call(els, (el) => {
		//console.log(el);

		let timeline = gsap.timeline({
			scrollTrigger: {
				triggerl: '.tile--grid',
				start: 'center top',
				end: 'bottom bottom',
				scrub: 1,
				markers: false,
			},
		});

		timeline.to('.tile--grid > div', {
			autoAlpha: 1,
			duration: 1,
			stagger: {
				each: 1,
				from: 'edges',
				grid: 'auto',
				ease: 'none',
			},
		});

		let tween = gsap.to('.tile--grid > div', {
			autoAlpha: 0,
			duration: 2,
			stagger: {
				each: 0.085,
				from: [0.5, 0.1],
				grid: 'auto',
				ease: 'none',
			},
			delay: 0,
		});

		tween.play();
	});
};
